import { render, staticRenderFns } from "./addPaper.vue?vue&type=template&id=db04d846&scoped=true"
import script from "./addPaper.vue?vue&type=script&lang=js"
export * from "./addPaper.vue?vue&type=script&lang=js"
import style0 from "./addPaper.vue?vue&type=style&index=0&id=db04d846&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db04d846",
  null
  
)

export default component.exports